import { clsx } from 'clsx';
import { Select } from 'antd';
import { useController } from 'react-hook-form';
import React, { useEffect, useMemo, useState } from 'react';
import { useResourceContext } from 'react-admin';

import { http } from '@network';
import { InitialRowProps } from '@components/InitialCard';
import cls from './OptionsAutocompleteFilter.module.css';

interface Props {
  source: string;
  entity?: string;
  label?: string;
  alwaysOn?: boolean;
  style?: React.CSSProperties;
}

export const OptionsAutocompleteFilter = ({
  label,
  source,
  entity,
  ...initialRowProps
}: Props & Omit<InitialRowProps, 'title'>) => {
  const resource = useResourceContext();
  const {
    fieldState: { error },
    field: { value, onChange },
  } = useController({ name: source });

  const [options, setOptions] = useState<string[]>([]);
  const selected = Array.isArray(value) ? value : value ? [value] : [];
  const errorMessage = (error as any)?.message?.message;

  const selectOptions = useMemo(
    () => options.map(option => ({ value: option, label: option })),
    [options],
  );

  useEffect(() => {
    (async () => {
      const url = `${entity || resource}/options/${source}`;
      const response = await http.get<string[]>(url);
      setOptions(response.data ?? []);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={cls.wrap} style={{ ...initialRowProps.style }}>
      <Select
        mode="multiple"
        showSearch
        allowClear
        value={selected}
        onChange={onChange}
        options={selectOptions}
        optionFilterProp="label"
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        className={cls.selectField}
        notFoundContent="Not found"
        status={errorMessage ? 'error' : undefined}
        maxTagCount="responsive"
      />
      {label ? (
        <span className={clsx(cls.label, selected.length > 0 && cls.labelFilled)}>
          {label}
        </span>
      ) : null}
      <span className={clsx(cls.search, selected.length > 0 && cls.searchHide)} />
    </div>
  );
};
